import { ChipGroup } from 'bricks-ui/packages/bricks-ui';

export default ChipGroup;
